import { render } from "./VideoViewControls.vue?vue&type=template&id=2daaf17a&scoped=true&ts=true"
import script from "./VideoViewControls.vue?vue&type=script&lang=ts"
export * from "./VideoViewControls.vue?vue&type=script&lang=ts"

import "./VideoViewControls.vue?vue&type=style&index=0&id=2daaf17a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daaf17a"]])

export default __exports__